import React from 'react';
import { skills } from '../data/content';

const skillGroups = [
  { label: 'Languages', key: 'languages' },
  { label: 'Mobile Frameworks', key: 'mobile' },
  { label: 'Backend & APIs', key: 'backend' },
  { label: 'Real-Time Systems', key: 'realTime' },
  { label: 'Performance & Optimization', key: 'performance' },
  { label: 'Payments', key: 'payments' },
  { label: 'Infrastructure', key: 'infrastructure' },
];

export default function Skills() {
  return (
    <section className="skills" id="skills">
      <p className="section-title">Technical Skills</p>
      <h2>What I work with</h2>
      <div className="skills__grid">
        {skillGroups.map(({ label, key }) => (
          <div key={key} className="skills__group">
            <h4 className="skills__group-title">{label}</h4>
            <div className="skills__tags">
              {skills[key].map((skill) => (
                <span key={skill} className="skills__tag">{skill}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
